import {Button, DatePicker, Flex, Form, Input, InputNumber, Modal, Radio, Select, Upload, message} from "antd";
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import styles from "./index.module.scss";
import jwtAxios from "../../../../auth/jwt-api";
import TextArea from "antd/es/input/TextArea";
import ReactInputMask from "react-input-mask";
import clsx from "clsx";
import translate from "../../../../i18n/translate";
import {useSelector} from "react-redux";
import {formatPriceParking} from "../../../../utils/formatPriceParking";
import {parseFormattedNumber} from "../../../../utils/parseFormattedNumber";
import {useAuthDatas} from "../../../../auth/JWTAuthProvider";
import {UploadOutlined} from "@ant-design/icons";

const {confirm} = Modal;

export default function OrderParkingModel({
                                              refetchInfo,
                                              refetchParking,
                                              order,
                                              searchParams,
                                              setSearchParams,
                                              parking,
                                          }) {
    const {rate} = useSelector(state => state.rate)
    const { user } = useAuthDatas();
    const {userData}=useSelector(state => state.userData)

    const isOpen = searchParams.orderParkingModel;
    const [loading, setLoading] = useState(false);
    const [currency, setCurrency] = useState("uzs");
    const [fileId, setFileId] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [clientType, setClientType] = useState("individual");
    const [clientInputMethod, setClientInputMethod] = useState("manual");
    const [signatories, setSignatories] = useState([]);
    const [form] = Form.useForm();

    // Calculate months remaining until February 2028
    const calculateMonthsToFeb2028 = () => {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1;
        const targetYear = 2028;
        const targetMonth = 2;
        const monthsRemaining = (targetYear - currentYear) * 12 + (targetMonth - currentMonth);
        return Math.max(0, monthsRemaining);
    };

    const [values, setValues] = useState({
        downPaymentPercent: 30,
        paymentDurationPerMonth: 24,
        isInstallmentPayment: false,
        downPaymentPercentDiscount: 0,
        booked: false,
        cashDiscountPercent: 15,
        isMortgage: false,
    });
    const [downPaymentSum, setDownPaymentSum] = useState(0);

    const getTotalPrice = () => {
        const basePrice = parking.pricePerMetrSquare * rate;
        const discount = values.isInstallmentPayment ? values.downPaymentPercentDiscount : values.cashDiscountPercent;
        return basePrice - ((basePrice * discount) / 100);
    };

    const typeValue = Form.useWatch('type', form);
    const isBookedReserved = values.booked && typeValue === "reserved";

    const handleUpload = async ({ file, onSuccess, onError }) => {
        const formData = new FormData();
        formData.append("file", file);
        try {
            const res = await jwtAxios.post("/media/upload", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setFileId(res.data?.data?.media?.id);
            onSuccess(res.data);
        } catch (err) {
            onError(err);
            message.error(translate("message.error.occurred"));
        }
    };

    const onFinish = async (data) => {

        setLoading(true);

        // First, create or get client
        const isMyId = clientType === "individual" && clientInputMethod === "myid";
        const clientData = isMyId ? {
            customerPhone: data.customerPhone,
            customerPhone2: data.customerPhone2,
            clientType: clientType,
            pnfl: data.pnfl,
            birthDate: data.birthDate ? data.birthDate.format("YYYY-MM-DD") : null,
        } : {
            customerName: data.customerName,
            customerPhone: data.customerPhone,
            customerPhone2: data.customerPhone2,
            email: data.email,
            address: data.address,
            clientType: clientType,
            // Individual fields
            passportGivenPlace: clientType === "individual" ? data.passportGivenPlace : null,
            passportGivenDate: clientType === "individual" && data.passportGivenDate ? data.passportGivenDate.format("YYYY-MM-DD") : null,
            series: clientType === "individual" ? data.series : null,
            pnfl: clientType === "individual" ? data.pnfl : null,
            birthDate: clientType === "individual" && data.birthDate ? data.birthDate.format("YYYY-MM-DD") : null,
            // Legal fields
            director: clientType === "legal" ? data.director : null,
            bank: clientType === "legal" ? data.bank : null,
            bank_account: clientType === "legal" ? data.bank_account : null,
            mfo_code: clientType === "legal" ? data.mfo_code : null,
            oked_code: clientType === "legal" ? data.oked_code : null,
            inn: clientType === "legal" ? data.inn : null,
        };

        let clientId = order?.client?.id || null;

        const dateFields = ["birthDate", "passportGivenDate"];
        const normalize = (val) => (val === null || val === undefined || val === "") ? "" : String(val);
        const isClientUnchanged = (existingClient) => {
            if (!existingClient) return false;
            return Object.keys(clientData).every(key => {
                const newVal = clientData[key];
                const oldVal = existingClient[key];
                if (dateFields.includes(key)) {
                    const newDate = newVal ? dayjs(newVal).format("YYYY-MM-DD") : "";
                    const oldDate = oldVal ? dayjs(oldVal).format("YYYY-MM-DD") : "";
                    return newDate === oldDate;
                }
                return normalize(newVal) === normalize(oldVal);
            });
        };

        try {
            if (userData?.id) {
                if (!isClientUnchanged(userData)) {
                    await jwtAxios.put(`/client/${userData.id}`, clientData);
                }
                clientId = userData.id;
            } else if (order?.id && order?.client?.id) {
                if (!isClientUnchanged(order.client)) {
                    await jwtAxios.put(`/client/${order.client.id}`, clientData);
                }
                clientId = order.client.id;
            } else {
                // Create new client
                const clientRes = await jwtAxios.post(`/client`, clientData);
                clientId = clientRes.data?.data?.client?.id;
            }
        } catch (error) {
            console.log('Client error:', error);
            setLoading(false);
            message.error(error.response?.data?.error || "Произошла ошибка");
            return;
        }

        // Remove client fields from order data
        delete data.customerName;
        delete data.customerPhone;
        delete data.customerPhone2;
        delete data.email;
        delete data.address;
        delete data.passportGivenPlace;
        delete data.passportGivenDate;
        delete data.series;
        delete data.pnfl;
        delete data.birthDate;
        delete data.director;
        delete data.bank;
        delete data.bank_account;
        delete data.mfo_code;
        delete data.oked_code;
        delete data.inn;

        data.clientId = clientId;
        data.userId=user.id
        const parkingPrice = parseFormattedNumber(formatPriceParking(parking, rate, 100));
        const storagePrice = parking?.storageRoomM2 && parking?.storageRoomPriceMetr
            ? Math.round(parking.storageRoomM2 * parking.storageRoomPriceMetr * rate * 10) / 10
            : 0;
        // Set price based on order type
        if (data.type === "reserved") {
            data.price = null;
        } else if (data.type === "reserved_paid") {
            data.price = data.bookingPayment || 5000000;
        } else {
            data.price = parkingPrice + storagePrice;
        }
        const discountPercent = values.isInstallmentPayment ? values.downPaymentPercentDiscount : values.cashDiscountPercent;
        const basePriceM2 = parking.pricePerMetrSquare * rate;
        data.price_m2 = Math.round((basePriceM2 - (basePriceM2 * discountPercent / 100)) * 10) / 10
        data.priceCurrency = currency;
        data.parkingId = searchParams.parkingId;

        // Set discount based on payment type
        if (values.isInstallmentPayment) {
            data.discount = values.downPaymentPercentDiscount;
            if (downPaymentSum) {
                data.downPaymentSum = downPaymentSum;
                data.downPaymentPercent = null;
            } else {
                data.downPaymentSum = null;
                data.downPaymentPercent = values.downPaymentPercent;
            }
        } else if (values.isMortgage) {
            data.discount = values.cashDiscountPercent;
            data.paymentDurationPerMonth = 0;
            data.bank = form.getFieldValue('mortgageBank');
            delete data.mortgageBank;
            if (downPaymentSum) {
                data.downPaymentSum = downPaymentSum;
                data.downPaymentPercent = null;
            } else {
                data.downPaymentSum = null;
                data.downPaymentPercent = values.downPaymentPercent;
            }
        } else {
            data.discount = values.cashDiscountPercent;
            data.downPaymentPercent = 100;
            data.paymentDurationPerMonth = 0;
        }

        if (fileId) data.file = fileId;
        try {
            if (order?.id) {
                await jwtAxios.patch(`/order/${order.id}`, data);
            } else {
                await jwtAxios.post(`/order`, data);
            }
            refetchInfo();
            refetchParking();
            setSearchParams({
                ...searchParams,
                orderParkingModel: undefined,
            });
            // message.success(translate("message.success.updated"));
        } catch (error) {
            // message.error(error.response?.data?.error || translate("message.error.occurred"));
            console.log(error);
        }
        setLoading(false);
        // },
        // });
    };
    useEffect(() => {
        if (isOpen) {
            jwtAxios.get("/signatory").then((res) => {
                const rows = res.data?.data?.results?.rows || [];
                setSignatories(rows.map((s) => ({ label: s.fullName, value: s.id })));
            }).catch(() => {});
        }
    }, [isOpen]);

    useEffect(() => {
        if (order) {
            setCurrency(order.priceCurrency);
            if (order.downPaymentSum) {
                setDownPaymentSum(order.downPaymentSum);
                const totalPrice = getTotalPrice();
                if (totalPrice) {
                    const percent = (order.downPaymentSum / totalPrice) * 100;
                    form.setFieldsValue({ downPaymentPercent: Math.round(percent * 100) / 100 });
                }
            }
            if (order.paymentDurationPerMonth) {
                setValues(v => ({ ...v, isInstallmentPayment: true, paymentDurationPerMonth: order.paymentDurationPerMonth }));
            } else if (order.downPaymentSum) {
                setValues(v => ({ ...v, isMortgage: true }));
            }
            form.setFields(
                Object.keys(order).map((key) => ({
                    name: key,
                    value: order[key],
                }))
            );
            // Set client fields from order.client
            if (order.client) {
                setClientType(order.client.clientType || "individual");
                form.setFieldsValue({
                    customerName: order.client.customerName,
                    customerPhone: order.client.customerPhone,
                    customerPhone2: order.client.customerPhone2,
                    email: order.client.email,
                    address: order.client.address,
                    passportGivenPlace: order.client.passportGivenPlace,
                    passportGivenDate: order.client.passportGivenDate ? dayjs(order.client.passportGivenDate) : null,
                    series: order.client.series,
                    pnfl: order.client.pnfl,
                    birthDate: order.client.birthDate ? dayjs(order.client.birthDate) : null,
                    director: order.client.director,
                    bank: order.client.bank,
                    bank_account: order.client.bank_account,
                    mfo_code: order.client.mfo_code,
                    oked_code: order.client.oked_code,
                    inn: order.client.inn,
                });
            }
        } else if (isOpen) {
            // const monthsRemaining = calculateMonthsToFeb2028();
            setValues(v => ({ ...v, paymentDurationPerMonth: 24 }));
            form.setFieldsValue({ paymentDurationPerMonth: 24 });
        }
    }, [isOpen, order?.id]);

    const onCancel = () => {
        form.resetFields();
        setValues({
            downPaymentPercent: 30,
            paymentDurationPerMonth: 24,
            isInstallmentPayment: false,
            downPaymentPercentDiscount: 0,
            booked: false,
            cashDiscountPercent: 15,
            isMortgage: false,
        });
        setDownPaymentSum(0);
        setCurrency("uzs");
        setClientType("individual");
        setClientInputMethod("manual");
        setFileId(null);
        setFileList([]);
        setSearchParams({
            ...searchParams,
            orderParkingModel: undefined,
        });
    };


    useEffect(() => {
        if (!order?.client && userData?.id) {
            setClientType(userData?.clientType || "individual");
            form.setFieldsValue({
                customerName: userData?.customerName || "",
                customerPhone: userData?.customerPhone || "",
                customerPhone2: userData?.customerPhone2 || "",
                email: userData?.email || "",
                address: userData?.address || "",
                // Individual fields
                passportGivenPlace: userData?.passportGivenPlace || "",
                passportGivenDate: userData?.passportGivenDate ? dayjs(userData.passportGivenDate) : null,
                series: userData?.series || "",
                pnfl: userData?.pnfl || "",
                birthDate: userData?.birthDate ? dayjs(userData.birthDate) : null,
                // Legal fields
                director: userData?.director || "",
                bank: userData?.bank || "",
                bank_account: userData?.bank_account || "",
                mfo_code: userData?.mfo_code || "",
                oked_code: userData?.oked_code || "",
                inn: userData?.inn || "",
            });
        }
    }, [userData]);
    return (
        <Modal
            centered
            open={!!isOpen}
            onCancel={onCancel}
            width={1000}
            title={translate("sale.info")}
            footer={""}
        >
            <Form
                onFinish={onFinish}
                layout="vertical"
                initialValues={{
                    type: "sold",
                    ...values,
                }}
                form={form}
            >
                <div
                    style={{
                        maxHeight: "70vh",
                        overflowX: "auto",
                    }}
                >
                    <table className={clsx(styles.table, "custom-table")}>
                        <tr>
                            <th>{translate("table.column.total_area")}</th>
                            <th>{translate("table.column.total_payment")}</th>
                            {values.isInstallmentPayment ? (
                                <>
                                    <th>
                                        {translate("table.column.initial_payment")}{" "}
                                        {Math.round(values.downPaymentPercent * 100) / 100}%
                                    </th>
                                    <th>
                                        {translate("table.column.monthly_payment")} (
                                        {values.paymentDurationPerMonth || 0}
                                        {translate("misc.month")})
                                    </th>
                                </>
                            ) : values.isMortgage ? (
                                <>
                                    <th>
                                        Первоначальный взнос{" "}
                                        {Math.round(values.downPaymentPercent * 100) / 100}%
                                    </th>
                                    <th>Остаток</th>
                                </>
                            ) : (
                                <th>
                                    {translate("table.column.total_payment_discount")}{" "}
                                    {values.cashDiscountPercent}%
                                </th>
                            )}
                        </tr>
                        <tr>
                            <td>
                                {" "}
                                {parseFloat(parking?.m2)} m<sup>2</sup>
                            </td>
                            <td>
                                {" "}
                                {(() => {
                                    const parkingPrice = parseFormattedNumber(formatPriceParking(parking, rate, 100));
                                    const storagePrice = parking?.storageRoomM2 && parking?.storageRoomPriceMetr
                                        ? Math.round(parking.storageRoomM2 * parking.storageRoomPriceMetr * rate * 10) / 10
                                        : 0;
                                    return (parkingPrice + storagePrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                                })()}{" "}
                                UZS
                            </td>
                            {values.isInstallmentPayment ? (
                                <>
                                    <td>
                                        {" "}
                                        {formatPriceParking(parking, rate, true, values)}{" "}
                                        UZS
                                    </td>
                                    <td>
                                        {" "}
                                        {formatPriceParking(parking, rate, false, values)}{" "}
                                        UZS
                                    </td>
                                </>
                            ) : values.isMortgage ? (
                                <>
                                    <td>
                                        {" "}
                                        {downPaymentSum
                                            ? downPaymentSum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                                            : Math.round(getTotalPrice() * values.downPaymentPercent / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                                        }{" "}
                                        UZS
                                    </td>
                                    <td>
                                        {" "}
                                        {(() => {
                                            const total = getTotalPrice();
                                            const dp = downPaymentSum || Math.round(total * values.downPaymentPercent / 100);
                                            return Math.round(total - dp).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                                        })()}{" "}
                                        UZS
                                    </td>
                                </>
                            ) : (
                                <td>
                                    {" "}
                                    {Math.round(getTotalPrice()).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}{" "}
                                    UZS
                                </td>
                            )}
                        </tr>
                    </table>
                    <br/>
                    <div style={{marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <div>
                            <span>{translate("form.label.client_type")}</span>
                            <br/>
                            <Radio.Group
                                value={clientType}
                                onChange={(e) => {
                                    setClientType(e.target.value);
                                    if (e.target.value === "legal") setClientInputMethod("manual");
                                }}
                            >
                                <Radio value="individual">{translate("form.label.individual")}</Radio>
                                <Radio value="legal">{translate("form.label.legal")}</Radio>
                            </Radio.Group>
                        </div>
                        {clientType === "individual" && (
                            <div>
                                <Radio.Group
                                    value={clientInputMethod}
                                    onChange={(e) => setClientInputMethod(e.target.value)}
                                >
                                    <Radio value="manual">{translate("form.label.manual")}</Radio>
                                    <Radio value="myid">{translate("form.label.via_myid")}</Radio>
                                </Radio.Group>
                            </div>
                        )}
                    </div>
                    <div className={styles.form}>
                        {!(clientInputMethod === "myid" && clientType === "individual") && (
                        <Form.Item
                            label={clientType === "legal" ? "Название фирмы" : translate("form.label.customer_name")}
                            name="customerName"
                            rules={[
                                {
                                    required: clientInputMethod !== "myid",
                                    message: translate("form.error.customer_name_required"),
                                },
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                        )}
                        <Form.Item
                            rules={[
                                {required: true, message: translate("form.error.customer_phone_required")},
                                {
                                    validator(_, data) {
                                        const phone = data?.replace(/\D/g, "");
                                        if (phone && phone.length !== 12 && phone.length !== 3) {
                                            return Promise.reject(translate("form.error.phone_incomplete"));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                            label={translate("form.label.customer_phone")}
                            name="customerPhone"
                        >
                            <ReactInputMask
                                style={{
                                    width: "100%",
                                }}
                                mask="+\9\98 99 999 99 99"
                                placeholder="+998 99 999 99 99"
                                name="phone"
                                id="phone"
                                className={"antd-input-style"}
                                type="tel"
                            />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {required: true, message: translate("form.error.customer_phone2_required")},
                                {
                                    validator(_, data) {
                                        const phone = data?.replace(/\D/g, "");
                                        if (phone && phone.length !== 12 && phone.length !== 3) {
                                            return Promise.reject(translate("form.error.phone_incomplete"));
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                            label={translate("form.label.customer_phone2")}
                            name="customerPhone2"
                        >
                            <ReactInputMask
                                style={{
                                    width: "100%",
                                }}
                                mask="+\9\98 99 999 99 99"
                                placeholder="+998 99 999 99 99"
                                name="phone2"
                                id="phone2"
                                className={"antd-input-style"}
                                type="tel"
                            />
                        </Form.Item>
                        {!isBookedReserved && !(clientInputMethod === "myid" && clientType === "individual") && (
                            <Form.Item
                                label={translate("form.label.email")}
                                name="email"
                            >
                                <Input type="email"/>
                            </Form.Item>
                        )}
                        <Form.Item label={translate("form.label.sale_status")} name="type" rules={[
                            {
                                required: true,
                                message: translate("form.error.type_required"),
                            },
                        ]}>
                            <Select
                                options={values.isInstallmentPayment ? [
                                    {
                                        label: translate("status.not_paid"),
                                        value: "not_full_paid",
                                    },
                                ] : values.isMortgage ? [
                                    {
                                        label: "Ипотека",
                                        value: "mortgage",
                                    },
                                ] : values.booked ? [
                                    {
                                        label: translate("status.booked"),
                                        value: "reserved",
                                    },
                                    {
                                        label: translate("status.reserved_paid"),
                                        value: "reserved_paid",
                                    },
                                ] : [
                                    {
                                        label: translate("status.sold"),
                                        value: "sold",
                                    }
                                ]}
                            />
                        </Form.Item>
                        {typeValue === "reserved_paid" && (
                            <Form.Item
                                label={translate("form.label.booking_payment")}
                                name="bookingPayment"
                                initialValue={5000000}
                                rules={[
                                    {
                                        required: true,
                                        message: translate("form.error.booking_payment_required"),
                                    },
                                ]}
                            >
                                <InputNumber
                                    style={{display: "block", width: "100%"}}
                                    min={0}
                                    addonAfter="UZS"
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/,/g, '')}
                                />
                            </Form.Item>
                        )}
                        {values.isInstallmentPayment && (
                            <Form.Item
                                label={translate("form.label.day_of_payment")}
                                name="day_of_payment"
                                rules={[
                                    {
                                        required: true,
                                        message: translate("form.error.day_of_payment_required"),
                                    },
                                ]}
                            >
                                <InputNumber
                                    style={{display: "block", width: "100%"}}
                                    min={1}
                                    max={28}
                                />
                            </Form.Item>
                        )}
                        {!isBookedReserved && !(clientInputMethod === "myid" && clientType === "individual") && (
                            <Form.Item
                                label={translate("form.label.address")}
                                name="address"
                            rules={[
                                {
                                    required: clientInputMethod !== "myid",
                                    message: translate("form.error.address_required"),
                                },
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                        )}
                        {!isBookedReserved && clientType === "individual" && !(clientInputMethod === "myid") && (
                            <>
                                <Form.Item
                                    label={translate("form.label.passport_given_place")}
                                    name="passportGivenPlace"
                                    rules={[
                                        {
                                            required: clientInputMethod !== "myid",
                                            message: translate("form.error.passport_given_place_required"),
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label={translate("form.label.passport_given_date")}
                                    name="passportGivenDate"
                                    rules={[
                                        {
                                            required: clientInputMethod !== "myid",
                                            message: translate("form.error.passport_given_date_required"),
                                        },
                                    ]}
                                >
                                    <DatePicker format="DD.MM.YYYY" style={{width: "100%"}}/>
                                </Form.Item>
                                <Form.Item
                                    label={translate("form.label.series")}
                                    name="series"
                                >
                                    <Input maxLength={9} onChange={(e) => {
                                        const raw = e.target.value.toUpperCase();
                                        const letters = raw.slice(0, 2).replace(/[^A-Z]/g, "");
                                        const digits = raw.slice(2).replace(/[^0-9]/g, "").slice(0, 7);
                                        form.setFieldsValue({ series: letters + digits });
                                    }}/>
                                </Form.Item>
                            </>
                        )}
                        {!isBookedReserved && clientType === "individual" && (
                            <>
                                <Form.Item
                                    label={translate("form.label.pnfl")}
                                    name="pnfl"
                                >
                                    <Input maxLength={14} onKeyPress={(e) => { if (!/[0-9]/.test(e.key)) e.preventDefault(); }}/>
                                </Form.Item>
                                <Form.Item
                                    label={translate("form.label.birth_date")}
                                    name="birthDate"
                                    rules={[
                                        {
                                            validator(_, value) {
                                                if (!value) return Promise.resolve();
                                                const age = dayjs().diff(value, 'year');
                                                if (age < 18) return Promise.reject(translate("form.error.birth_date_min_age"));
                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                >
                                    <DatePicker format="DD.MM.YYYY" style={{width: "100%"}}/>
                                </Form.Item>
                            </>
                        )}
                        {!isBookedReserved && clientType === "legal" && (
                            <>
                                <Form.Item
                                    label={translate("form.label.director")}
                                    name="director"
                                    rules={[
                                        {
                                            required: true,
                                            message: translate("form.error.director_required"),
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label={translate("form.label.bank")}
                                    name="bank"
                                    rules={[
                                        {
                                            required: true,
                                            message: translate("form.error.bank_required"),
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label={translate("form.label.bank_account")}
                                    name="bank_account"
                                    rules={[
                                        {
                                            required: true,
                                            message: translate("form.error.bank_account_required"),
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label={translate("form.label.mfo_code")}
                                    name="mfo_code"
                                    rules={[
                                        {
                                            required: true,
                                            message: translate("form.error.mfo_code_required"),
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label={translate("form.label.oked_code")}
                                    name="oked_code"
                                    rules={[
                                        {
                                            required: true,
                                            message: translate("form.error.oked_code_required"),
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    label={translate("form.label.inn")}
                                    name="inn"
                                    rules={[
                                        {
                                            required: true,
                                            message: translate("form.error.inn_required"),
                                        },
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                            </>
                        )}

                        {values.isMortgage && !isBookedReserved && (
                            <Form.Item
                                label="Банк"
                                name="mortgageBank"
                                rules={[
                                    {
                                        required: true,
                                        message: "Банкни танланг",
                                    },
                                ]}
                            >
                                <Select
                                    placeholder="Банкни танланг"
                                    options={[
                                        { label: "Orient Finans Bank", value: "OFB" },
                                        { label: "Ipak Yo'li Bank", value: "IYB" },
                                        { label: "Sanoat Qurilish Bank", value: "SQB" },
                                        { label: "IFB Bank", value: "IFB" },
                                    ]}
                                />
                            </Form.Item>
                        )}
                        {(values.isInstallmentPayment || values.isMortgage) && !isBookedReserved && (
                            <>
                                <Form.Item
                                    label={translate("form.label.initial_payment")}
                                    name="downPaymentPercent"
                                    rules={[
                                        {
                                            required: true,
                                            message: translate("form.error.initial_payment_required"),
                                        },
                                    ]}
                                >
                                    <InputNumber
                                        style={{display: "block", width: "100%"}}
                                        type="number"
                                        min={0}
                                        addonAfter={translate("misc.percent")}
                                        onChange={(downPaymentPercent) => {
                                            setValues((values) => ({
                                                ...values,
                                                downPaymentPercent,
                                            }));
                                            const totalPrice = getTotalPrice();
                                            if (totalPrice && downPaymentPercent != null) {
                                                setDownPaymentSum(Math.round(totalPrice * downPaymentPercent / 100));
                                            }
                                        }}
                                    />
                                </Form.Item>{" "}
                                <Form.Item
                                    label="Первоначальный взнос (сум)"
                                >
                                    <InputNumber
                                        style={{display: "block", width: "100%"}}
                                        min={0}
                                        addonAfter="UZS"
                                        value={downPaymentSum}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/,/g, '')}
                                        onChange={(sum) => {
                                            setDownPaymentSum(sum);
                                            const totalPrice = getTotalPrice();
                                            if (totalPrice && sum) {
                                                const percent = (sum / totalPrice) * 100;
                                                setValues((values) => ({
                                                    ...values,
                                                    downPaymentPercent: percent,
                                                }));
                                                form.setFieldsValue({ downPaymentPercent: Math.round(percent * 100) / 100 });
                                            }
                                        }}
                                    />
                                </Form.Item>{" "}
                                {values.isInstallmentPayment && (
                                    <>
                                    <Form.Item
                                        label={translate("form.label.payment_duration")}
                                        name="paymentDurationPerMonth"
                                        rules={[
                                            {
                                                required: true,
                                                message: translate("form.error.duration_required"),
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{display: "block", width: "100%"}}
                                            type="number"
                                            addonAfter={translate("misc.month")}
                                            onChange={(paymentDurationPerMonth) => {
                                                setValues((values) => ({
                                                    ...values,
                                                    paymentDurationPerMonth,
                                                }));
                                            }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={translate("form.label.initial_payment_discount")}
                                        name="downPaymentPercentDiscount"
                                        rules={[
                                            {
                                                required: true,
                                                message: translate("form.error.initial_payment_discount_required"),
                                            },
                                        ]}
                                    >
                                        <InputNumber
                                            style={{display: "block", width: "100%"}}
                                            type="number"
                                            min={0}
                                            max={50}
                                            addonAfter={translate("misc.percent")}
                                            onChange={(downPaymentPercentDiscount) => {
                                                setValues((values) => ({
                                                    ...values,
                                                    downPaymentPercentDiscount,
                                                }));
                                            }}
                                        />
                                    </Form.Item>{" "}
                                    </>
                                )}
                            </>
                        )}
                    </div>

                    {!values.isInstallmentPayment && !values.booked && !isBookedReserved && (
                        <div style={{marginTop: 16}}>
                            <Form.Item
                                label={translate("form.label.initial_payment_discount")}
                                name="cashDiscountPercent"
                                initialValue={15}
                            >
                                <InputNumber
                                    style={{display: "block", width: "100%"}}
                                    type="number"
                                    min={0}
                                    max={50}
                                    addonAfter={translate("misc.percent")}
                                    onChange={(cashDiscountPercent) => {
                                        setValues((values) => ({
                                            ...values,
                                            cashDiscountPercent,
                                        }));
                                    }}
                                />
                            </Form.Item>
                        </div>
                    )}

                    <div style={{marginTop: 16}}>
                        <span>{translate("form.label.payment_method")}</span>
                        <br/>
                        <Select
                            value={values.isInstallmentPayment ? "installment" : values.isMortgage ? "mortgage" : values.booked ? "booked" : "cash"}
                            onChange={(value) => {
                                const newIsInstallment = value === "installment";
                                const newIsMortgage = value === "mortgage";
                                setValues((prev) => ({
                                    ...prev,
                                    isInstallmentPayment: newIsInstallment,
                                    isMortgage: newIsMortgage,
                                    booked: value === "booked",
                                }));
                                // Calculate downPaymentSum based on 30% when switching to installment or mortgage
                                if (newIsInstallment || newIsMortgage) {
                                    const discount = newIsMortgage ? values.cashDiscountPercent : values.downPaymentPercentDiscount;
                                    const basePrice = parking.pricePerMetrSquare * rate;
                                    const totalPrice = basePrice - ((basePrice * discount) / 100);
                                    setDownPaymentSum(Math.round(totalPrice * values.downPaymentPercent / 100));
                                } else {
                                    setDownPaymentSum(0);
                                }
                                form.setFieldValue('type', undefined);
                            }}
                            options={[
                                {
                                    label: translate("form.label.booked"),
                                    value: "booked",
                                },
                                {
                                    label: translate("payment.cash"),
                                    value: "cash",
                                },
                                {
                                    label: translate("form.label.installment"),
                                    value: "installment",
                                },
                                {
                                    label: "Ипотека",
                                    value: "mortgage",
                                },
                            ]}
                        />
                    </div>

                    <br/>

                    <Form.Item
                        label={translate("form.label.signatory")}
                        name="signatoryId"
                        rules={[{ required: true, message: translate("form.error.signatory_required") }]}
                    >
                        <Select
                            placeholder={translate("form.error.signatory_required")}
                            options={signatories}
                        />
                    </Form.Item>

                    {!isBookedReserved && (
                        <Form.Item label={translate("form.label.additional_info")} name="description">
                            <TextArea/>
                        </Form.Item>
                    )}

                    {!isBookedReserved && (
                        <div style={{ marginTop: 16 }}>
                            <Upload
                                customRequest={handleUpload}
                                fileList={fileList}
                                onChange={({ fileList: newList }) => setFileList(newList.slice(-1))}
                                onRemove={() => setFileId(null)}
                                maxCount={1}
                            >
                                <Button icon={<UploadOutlined />}>
                                    {translate("form.label.upload_file")}
                                </Button>
                            </Upload>
                        </div>
                    )}

                    {!isBookedReserved && (
                        <Form.Item label={translate("form.label.file_comment")} name="file_comment" style={{ marginTop: 16 }}>
                            <TextArea placeholder={translate("form.label.file_comment")}/>
                        </Form.Item>
                    )}
                </div>

                <Form.Item>
                    <Flex
                        align="flex-end"
                        justify="flex-end"
                        gap={10}
                        wrap="nowrap"
                        style={{paddingTop: 20}}
                    >
                        <Button
                            type="primary"
                            ghost
                            htmlType="button"
                            loading={loading}
                            onClick={onCancel}
                        >
                            {translate("button.cancel")}
                        </Button>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            {translate("button.submit")}
                        </Button>
                    </Flex>
                </Form.Item>
            </Form>
        </Modal>
    );
}
